import React from 'react';
import classes from './BuildControl.module.css'

const buildControl = (props) => {
    return <div className={classes.BuildControl}>
                <div className={classes.Label}>{props.ingredientLabel}</div>

                <button 
                    className={classes.Less}
                    onClick={props.remove}
                    disabled={props.disable} >Less</button>

                <button className={classes.More}
                    onClick={props.added}
                    >More</button>
            </div>
}

export default buildControl;